import React from "react";
import Notification from "@/components/Notification";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Layout = ({ children }) => {
	return (
		<React.Fragment>
			<Notification />
			<Header />
			<main>{children}</main>
			<Footer />
		</React.Fragment>
	);
};

export default Layout;
